// Validaciones de campos del formulario de autorregistro.
// Cada función devuelve el mensaje de error o `null` si es válido.
// El caso "vacío" devuelve null: la obligatoriedad se valida aparte (campo requerido).

import { fechaISO, fechaNacimientoMinima, hoyEnChile } from './dateHelpers';
import { parseDateOnly } from './formatters';

export const validarFechaNacimiento = (value: string): string | null => {
  const v = value.trim();
  if (!v) return null;
  const fecha = parseDateOnly(v);
  if (Number.isNaN(fecha.getTime())) return 'Fecha inválida';
  // Reformateada debe coincidir con el texto: rechaza fechas inexistentes (02-30) y años < 100
  const dia = fechaISO(fecha);
  if (dia !== v) return 'Fecha inválida';
  // Día civil contra el "hoy" de Chile, comparados como texto 'YYYY-MM-DD'
  const hoy = hoyEnChile();
  if (dia > hoy) return 'La fecha no puede ser futura';
  if (dia < fechaNacimientoMinima(parseDateOnly(hoy))) return 'Revisa la fecha de nacimiento';
  return null;
};

export const validarMontoEntero = (value: string): string | null => {
  const v = value.trim();
  if (!v) return null;
  const n = Number(v);
  if (!Number.isInteger(n) || n < 0) return 'Ingresa un monto entero (0 o mayor)';
  return null;
};
